import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "../reducer";
import {
  readPreloadedChatUnread,
  writePersistedChatUnread,
} from "../chatUnreadPersist";

const preloadedChatUnread = readPreloadedChatUnread();

const store = configureStore({
  reducer: rootReducer,
  ...(preloadedChatUnread ? { preloadedState: preloadedChatUnread } : {}),
});

let lastChatUnreadSerialized = "";
const syncChatUnreadToLocalStorage = () => {
  const chatUnread = store.getState().chatUnread;
  const serialized = JSON.stringify(chatUnread);
  if (serialized === lastChatUnreadSerialized) return;
  lastChatUnreadSerialized = serialized;
  writePersistedChatUnread(chatUnread);
};

store.subscribe(syncChatUnreadToLocalStorage);

export default store;
